// O nome da outra pessoa, a partir de quem está com a sessão aberta.
//
// Existe para que nenhuma página tenha de escrever "ela" ou "a outra pessoa":
// as duas formas estavam escritas de um só lado do casal e liam-se mal na
// conta da outra. Um nome não tem género com que concordar.

import { partnerName } from "@historia/shared/content";
import { useSession } from "@/api/session";

export function useOutroNome(): string {
  const { user } = useSession();
  return partnerName(user?.name ?? user?.email);
}
